// extracted by mini-css-extract-plugin
export default {"errors":"ConfigurationErrors_errors__TPC4X"};